/* eslint-disable */
import React, { Component, useState } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import List from "@material-ui/core/List";
import {FormControl, FormLabel, HStack, Menu, Stack} from "@chakra-ui/react";
import {
  AccordionActions, Button as ButtonMat, Chip,
  createStyles,
  Divider,
  Input,
  MenuItem,
  Select as SelectMultiple,
  Theme,
  withStyles
} from "@material-ui/core";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";

import {edit_Properties_list, getAllProperties, selectAvailableLanguageAction} from "../../../utils/store/actions/users.actions";
import {getEnums} from "../../../utils/store/actions/survey.action";


const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    dropzoneEmail: {},
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },
  });

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 800,
    },
  },
};

class Internationalisation extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedOptions: [],
      countriesList: [],
      availableLanguages: [],
    };
  }

  async componentDidMount() {
    const { Users } = this.props;
    const allProperties = Users?.get_properties as Property[] || [];

    const zoneProperties = allProperties.find((item) => item.key === 'GEOGRAPHICAL_ZONE');
    const zonePropertiesSelected = zoneProperties?.values || [''];

    const langs = this.props.Users?.availableLanguages as AvailableLanguageDTO[] || [];
    const languageCodes = langs.filter(item => item.isSelected).map((item) => item.languageCode);

    this.setState({
      availableLanguages: languageCodes,
      selectedOptions: zonePropertiesSelected
    });
  }

  handleChangePropertyList = (event: any, property: any) => {
    let propArray: any;
    if (Array.isArray(property.values)) {
      propArray = property.values;
    } else {
      propArray = [""];
    }
    if (propArray.includes(event.props?.value)) {
      propArray.splice(propArray.indexOf(event.props?.value));
    } else {
      propArray.push(event.props?.value);
    }
    this.setState({selectedOptions: propArray});
  };

  handleChangeAvailableLanguages = (property: any) => {
    let propArray = this.state.availableLanguages;
    if (propArray.includes(property.props?.value)) {
      propArray.splice(propArray.indexOf(property.props?.value), 1);
    } else {
      propArray.push(property.props?.value);
    }
    this.setState({availableLanguages: propArray});
  };


  handleSubmit = () => {
    this.props
      .edit_Properties_list({
        key: "GEOGRAPHICAL_ZONE",
        values: this.state.selectedOptions,
      })
      .then(() => this.props.getAllProperties());

    this.props.selectAvailableLanguageAction(this.state.availableLanguages);
  }

  render() {
    const { classes, t } = this.props;
    return (
      <Accordion
        className={classes.accordion}
        style={{ flexDirection: "column" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  />}
          aria-controls="panel2a-content"
          id="modules"
        >
          <Typography className={classes.heading}>{t('INTERNATIONALISATION')}</Typography>
        </AccordionSummary>
        <FormControl></FormControl>
        <AccordionDetails>
        <List className={classes.root}>
          {this.props.Users?.availableLanguages && this.props.Users?.availableLanguages?.length > 0 && (
              <>
                <FormControl id="availableLanguages">
                  <FormLabel>{t('AVAILABLE_LANGUAGE')}</FormLabel>
                  <SelectMultiple
                    labelId="demo-mutiple-chip-label"
                    multiple
                    value={this.state.availableLanguages || [""]}
                    onChange={(e: any, value: any) => {
                      this.handleChangeAvailableLanguages(value);
                    }}
                    renderValue={(selected: any) => (
                      <div className={classes.chips}>
                        {selected.map((value: any) => {
                          return (
                            <Chip
                              style={{ maxWidth: "200px" }}
                              key={value}
                              label={this.props.t(`ENUMS.LANGUAGES.${value.toUpperCase()}`)}
                              className={classes.chip}
                            />
                          );
                        })}
                      </div>
                    )}
                    input={<Input id="select-multiple-chip" />}
                    MenuProps={MenuProps}
                  >
                    {this.props.Users?.availableLanguages
                    .map((lang: any) => {
                        return (
                          <MenuItem
                            id="banks"
                            key={lang.languageCode}
                            value={lang.languageCode}
                          >
                            {this.props.t(`ENUMS.LANGUAGES.${lang.languageCode.toUpperCase()}`)}
                          </MenuItem>
                        );
                      })}
                  </SelectMultiple>
                </FormControl>
              </>
          )}
        </List>
        </AccordionDetails>

        <AccordionDetails>
        <List className={classes.root}>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) => {
              return (
                property.key === "GEOGRAPHICAL_ZONE" && (
                  <FormControl id="propertyGeographicalZone">
                    <FormLabel>{t('CHOOSE_ZONE')}</FormLabel>
                    <SelectMultiple
                      labelId="demo-mutiple-chip-label"
                      multiple
                      value={property.values || [""]}
                      onChange={(e: any, value: any) => {
                        this.handleChangePropertyList(value, property);
                      }}
                      renderValue={(selected: any) => (
                        <div className={classes.chips}>
                          {selected.map((value: any) => {
                            const label =
                              this.props.Surveys?.enumsFiltered &&
                              this.props.Surveys?.enumsFiltered[
                                "countries"
                              ]?.find((obj: any) => obj.key === value)
                                ?.label;
                            return (
                              <Chip
                                style={{ maxWidth: "200px" }}
                                key={value}
                                label={
                                  label
                                    ? this.props.t("ENUMS." + label)
                                    : ""
                                }
                                className={classes.chip}
                              />
                            );
                          })}
                        </div>
                      )}
                      input={<Input id="select-multiple-chip" />}
                      MenuProps={MenuProps}
                    >
                      {this.props.Surveys?.enumsFiltered &&
                        this.props.Surveys?.enumsFiltered[
                          "countries"
                        ]?.map((obj: any) => {
                          return (
                            <MenuItem
                              id="banks"
                              key={obj.key}
                              value={obj.key}
                            >
                              {this.props.t("ENUMS." + obj?.label)}
                            </MenuItem>
                          );
                        })}
                    </SelectMultiple>
                  </FormControl>
                )
              );
            }
          )}
        </List>

        </AccordionDetails>
        <Divider />
        <AccordionActions>
          <ButtonMat
            size="small"
            style={{ color: "#ae0064" }}
            onClick={this.handleSubmit}
          >
            {t("SAVE")}
          </ButtonMat>
        </AccordionActions>
      </Accordion>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllProperties,
  edit_Properties_list,
  selectAvailableLanguageAction,
  getEnums
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Internationalisation)));
